var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatTeardropText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25004 2.5C6.85766 2.5 5.5223 3.05312 4.53773 4.03769C3.55316 5.02226 3.00004 6.35761 3.00004 7.75V13H8.25004C8.93948 13 9.62217 12.8642 10.2591 12.6004C10.8961 12.3365 11.4748 11.9498 11.9624 11.4623C12.4499 10.9748 12.8366 10.396 13.1004 9.75909C13.3642 9.12213 13.5 8.43944 13.5 7.75C13.5 7.06056 13.3642 6.37787 13.1004 5.74091C12.8366 5.10395 12.4499 4.5252 11.9624 4.03769C11.4748 3.55018 10.8961 3.16347 10.2591 2.89963C9.62217 2.6358 8.93948 2.5 8.25004 2.5ZM8.25004 14H2.98402C2.85513 14.0012 2.72728 13.9768 2.60786 13.9283C2.48723 13.8792 2.37765 13.8065 2.28557 13.7145C2.1935 13.6224 2.1208 13.5128 2.07177 13.3922C2.02322 13.2728 1.99885 13.1449 2.00004 13.016V7.75C2.00004 6.0924 2.65852 4.50268 3.83062 3.33058C5.00273 2.15848 6.59244 1.5 8.25004 1.5C9.0708 1.5 9.88353 1.66166 10.6418 1.97575C11.4001 2.28984 12.0891 2.75022 12.6695 3.33058C13.2498 3.91095 13.7102 4.59994 14.0243 5.35823C14.3384 6.11651 14.5 6.92924 14.5 7.75C14.5 8.57076 14.3384 9.38349 14.0243 10.1418C13.7102 10.9001 13.2498 11.5891 12.6695 12.1694C12.0891 12.7498 11.4001 13.2102 10.6418 13.5242C9.88353 13.8383 9.0708 14 8.25004 14Z",
    fill: "#0E1111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 7C5.75 6.72386 5.97386 6.5 6.25 6.5H10C10.2761 6.5 10.5 6.72386 10.5 7C10.5 7.27614 10.2761 7.5 10 7.5H6.25C5.97386 7.5 5.75 7.27614 5.75 7Z",
    fill: "#0E1111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 9C5.75 8.72386 5.97386 8.5 6.25 8.5H10C10.2761 8.5 10.5 8.72386 10.5 9C10.5 9.27614 10.2761 9.5 10 9.5H6.25C5.97386 9.5 5.75 9.27614 5.75 9Z",
    fill: "#0E1111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropText);
export default __webpack_public_path__ + "static/media/ChatTeardropText.0d36b8a5825c345967a06d46d03af7a8.svg";
export { ForwardRef as ReactComponent };